let apirl = ''
if (process.env.NODE_ENV === 'production') {
  apirl = location.origin
} else {
  apirl = 'https://demostruk.aviana.id'
}

export const apiurl = apirl
